import React, { useState } from 'react';
import useReveal from '../../hooks/useReveal';
import CaseStudyCard from './CaseStudyCard';
import './CaseStudyListing.css';

const CaseStudyListing = ({ branches, posts }) => {
  const sectionRef = useReveal({ threshold: 0.1 });
  const [selectedBranch, setSelectedBranch] = useState(null);

  const handleBranchClick = (branch) => {
    setSelectedBranch(branch === selectedBranch ? null : branch);
  };

  const filteredPosts = selectedBranch
    ? posts.filter((post) => post.branch === selectedBranch)
    : posts;

  return (
    <section className="case-study-listing reveal" ref={sectionRef}>
      <div className="case-study-listing-filters">
        <span className="case-study-listing-label">Branchen:</span>

        <button
          type="button"
          className={`case-study-filter ${selectedBranch === null ? 'active' : ''}`}
          onClick={() => setSelectedBranch(null)}
        >
          Alle
        </button>

        {branches.map((branch) => (
          <button
            type="button"
            key={branch}
            className={`case-study-filter ${selectedBranch === branch ? 'active' : ''}`}
            onClick={() => handleBranchClick(branch)}
          >
            {branch}
          </button>
        ))}
      </div>

      <div className="case-study-listing-cards">
        {filteredPosts.length === 0 ? (
          <p className="case-study-listing-empty">
            Für diese Branche ist aktuell keine Case Study verfügbar.
          </p>
        ) : (
          filteredPosts.map((post, index) => (
            <div
              key={post.slug}
              className="case-study-listing-item"
              style={{ '--card-delay': `${index * 90}ms` }}
            >
              <CaseStudyCard post={post} variant="row" />
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default CaseStudyListing;
